import * as React from 'react'

import Button from '../../../../components/button'

import { defineMessages, FormattedHTMLMessage } from 'react-intl'

import styles from './hero.module.scss'
import PromoNewCompanies from '../promo-new-companies'
import FreeHandwriting from '../../../free/components/free-handwriting'
import logo from './voitto-logo.svg'

export const messages = defineMessages({
  seeHowItWorks: {
    defaultMessage: 'See how it works',
    id: 'start.hero.see-how-it-works',
  },
  buttonOrder: {
    defaultMessage: 'Få ditt pris',
    id: 'start.hero.button-order',
  },
  buttonOrderCampaign: {
    defaultMessage: 'Ja, fixa min bokföring',
    id: 'start.hero.button-order-campaign',
  },
  buttonMore: {
    defaultMessage: 'Mer om oss',
    id: 'start.hero.button-more',
  },
  buttonMoreNewCompanies: {
    defaultMessage: 'Vad menar ni egenteligen?',
    id: 'start.hero.button-more-new-companies',
  },
  moreCampaign: {
    defaultMessage: 'Gäller till 8 december!',
    id: 'start.hero.more-campaign',
  },
  heading: {
    defaultMessage: 'Du fokuserar på ditt företag. Vi sköter din bokföring.',
    id: 'start.hero.heading-1',
  },
  headingCampaign: {
    defaultMessage: 'Låt Dooer boka ikapp hela 2019 utan kostnad',
    id: 'start.hero.heading-campaign',
  },
  lede: {
    defaultMessage:
      'Vi gör det vi älskar vilket är bokföring. Med Dooer får du full kontroll över ditt företag i vår bokföringstjänst.',
    id: 'start.hero.lede',
  },
  ledeCampaign: {
    defaultMessage:
      'Lugn, vi fixar det här! Om du har ett nystartat bolag och inte kommit igång med bokföringen så bokar vi ikapp 2019 utan kostnad när du blir kund.',
    id: 'start.hero.lede-campaign',
  },
  headingPromoNewCompanies: {
    defaultMessage: 'Börja betala när cashen rullar in',
    id: 'start.hero.heading-new-companies',
  },
  ledePromoNewCompanies: {
    defaultMessage:
      'Beställ Dooer till ditt nystartade bolag så tar vi hand om all din bokföring kostnadsfritt fram tills du börjar dra in pengar. Sedan kostar det från 895 kr/mån.',
    id: 'start.hero.lede-campaign-new-companies',
  },
  buttonOrderPromoNewCompanies: {
    defaultMessage: 'Perfekt, jag är nystartad',
    id: 'start.hero.button-order-new-companies',
  },
  blob: {
    defaultMessage: 'Just nu!',
    id: 'start.hero.blob.heading',
  },
})

// Component interface
interface IStartProps {
  variant?: 'regular' | 'campaign' | 'videoPromo' | 'promoNewCompanies'
}

// Dynamically render basic content like heading and lede
function renderBasicContent(variant: 'regular' | 'campaign' | 'videoPromo' | 'promoNewCompanies') {
  const content = {
    regular: {
      heading: messages.heading,
      lede: messages.lede,
      buttonOrder: messages.buttonOrder,
      buttonMore: messages.buttonMore,
    },
    campaign: {
      heading: messages.headingCampaign,
      lede: messages.ledeCampaign,
      buttonOrder: messages.buttonOrderCampaign,
    },
    videoPromo: {
      heading: messages.heading,
      lede: messages.lede,
      buttonOrder: messages.buttonOrder,
    },
    promoNewCompanies: {
      heading: messages.headingPromoNewCompanies,
      lede: messages.ledePromoNewCompanies,
      buttonOrder: messages.buttonOrderPromoNewCompanies,
    },
  }

  return content[variant]
}

// Dynamically render classname for outer div
function renderOuterClassname(variant: 'regular' | 'campaign' | 'videoPromo' | 'promoNewCompanies') {
  const classNames = {
    regular: styles.outer,
    campaign: styles.outerCampaign,
    videoPromo: styles.outerVideoPromo,
    promoNewCompanies: styles.outerPromoNewCompanies,
  }

  return classNames[variant]
}

export default function Start({ variant = 'regular' }: IStartProps) {
  return (
    <div style={{ position: 'relative' }}>
      <div className={renderOuterClassname(variant)}>
        <div className={styles.inner}>
          <div className={styles.text}>
            <h1 className={styles.heading}>
              <FormattedHTMLMessage {...renderBasicContent(variant).heading} />
            </h1>
            <p className={styles.lede}>
              <span>
                <FormattedHTMLMessage {...renderBasicContent(variant).lede} />
              </span>
            </p>
            <div className={styles.buttonWrapper}>
              <FreeHandwriting color="white" variant="left" />
              <Button className={styles.button} href="https://www.voitto.se/" target="_blank">
                <FormattedHTMLMessage {...renderBasicContent(variant).buttonOrder} />
                <img alt="logo" src={logo} />
              </Button>
            </div>
          </div>
        </div>
      </div>
      {variant === 'promoNewCompanies' && (
        <div className={styles.promoNewCompaniesWrapper}>
          <PromoNewCompanies />
        </div>
      )}
    </div>
  )
}
